export default {

}



// WEBPACK FOOTER //
// ./src/app/professional/loading-page/gadget/components/professional/resources/index.js